export const remainingBudget = (budget, budget_spent) => ( budget - budget_spent );

export default remainingBudget;